import React from 'react';
import { CalendarIcon, ClockIcon, UserIcon, VideoIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export const ScheduleSection = () => {
  const appointments = [{
    id: 1,
    clientName: 'Robert & Emily Chen',
    time: '10:30 AM',
    type: 'video',
    status: 'upcoming',
    topic: 'Honeymoon Planning'
  }, {
    id: 2,
    clientName: 'Michael Torres',
    time: '1:00 PM',
    type: 'in-person',
    status: 'upcoming',
    topic: 'Europe Tour Package'
  }, {
    id: 3,
    clientName: 'Jennifer Williams',
    time: '3:15 PM',
    type: 'phone',
    status: 'upcoming',
    topic: 'Cruise Booking'
  }];
  const getAppointmentIcon = (type: string) => {
    switch (type) {
      case 'video':
        return <VideoIcon className="h-4 w-4 text-purple-500" data-id="element-2370" />;
      case 'phone':
        return <PhoneIcon className="h-4 w-4 text-blue-500" data-id="element-2371" />;
      case 'in-person':
        return <MapPinIcon className="h-4 w-4 text-green-500" data-id="element-2372" />;
      default:
        return <UserIcon className="h-4 w-4 text-gray-500" data-id="element-2373" />;
    }
  };
  return <div className="bg-white rounded-lg shadow-md p-4" data-id="element-2374">
      <div className="flex items-center justify-between mb-4" data-id="element-2375">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-2376">Today's Schedule</h2>
        <button className="text-sm text-blue-600 hover:text-blue-800 flex items-center" data-id="element-2377">
          <CalendarIcon className="h-4 w-4 mr-1" data-id="element-2378" />
          Calendar
        </button>
      </div>
      <div className="relative pl-6 before:content-[''] before:absolute before:left-2 before:top-0 before:bottom-0 before:w-0.5 before:bg-gray-200" data-id="element-2379">
        {appointments.map((appointment, index) => <div key={appointment.id} className={`mb-4 relative before:content-[''] before:absolute before:left-[-20px] before:top-2 before:w-4 before:h-4 before:rounded-full ${index === 0 ? 'before:bg-green-500 before:ring-4 before:ring-green-100' : 'before:bg-gray-300'}`} data-id="element-2380">
            <div className="bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition-shadow" data-id="element-2381">
              <div className="flex items-center justify-between" data-id="element-2382">
                <div className="flex items-center" data-id="element-2383">
                  <ClockIcon className="h-4 w-4 text-gray-400 mr-1.5" data-id="element-2384" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-2385">
                    {appointment.time}
                  </span>
                </div>
                <div className="flex items-center text-xs text-gray-500" data-id="element-2386">
                  {getAppointmentIcon(appointment.type)}
                  <span className="ml-1 capitalize" data-id="element-2387">{appointment.type}</span>
                </div>
              </div>
              <div className="mt-2" data-id="element-2388">
                <p className="font-medium text-gray-800" data-id="element-2389">
                  {appointment.clientName}
                </p>
                <p className="text-sm text-gray-600" data-id="element-2390">{appointment.topic}</p>
              </div>
              <div className="mt-3 flex justify-end space-x-2" data-id="element-2391">
                <button className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200" data-id="element-2392">
                  Reschedule
                </button>
                <button className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700" data-id="element-2393">
                  Prepare
                </button>
              </div>
            </div>
          </div>)}
      </div>
      <button className="w-full mt-2 text-center text-sm text-blue-600 hover:text-blue-800" data-id="element-2394">
        View All Appointments
      </button>
    </div>;
};